import CryptoJS from 'crypto-js'

export default {
    // 随机生成指定数量的16进制key
    generatekey(num: any) {
      let library = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let key = ''
      for (let i = 0; i < num; i++) {
        let randomPoz = Math.floor(Math.random() * library.length)
        key += library.substring(randomPoz, randomPoz + 1)
      }
      return key
    },
    // 加密
    encrypt(word: any) {
      // 生产： da92e33a96cd32a1   阿里： 2012bdeec037d05a
      const keyStr = (window.location.host === 'liveness.advai.net' || window.location.host === 'localhost:8080') ? '2012bdeec037d05a' : 'da92e33a96cd32a1'
      // keyStr = keyStr ? keyStr : 'da92e33a96cd32a1' // 判断是否存在ksy，不存在就用定义好的key
      const key = CryptoJS.enc.Utf8.parse(keyStr)
      const srcs = CryptoJS.enc.Utf8.parse(word)
      const encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
      return encrypted.toString()
    },
    // 解密
    decrypt(word: any, keyStr: any) {
      keyStr = keyStr ? keyStr : 'da92e33a96cd32a1'
      const key = CryptoJS.enc.Utf8.parse(keyStr)
      const decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
      return CryptoJS.enc.Utf8.stringify(decrypt).toString()
    },
}
